module.exports = __webpack_public_path__ + "static/media/HEART-1.957a17ec.svg";